import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/authConfig";
import "./styles/global.css";
import App from "./App";

async function bootstrap() {
  await msalInstance.initialize();

  try {
    await msalInstance.handleRedirectPromise();
  } catch (err) {
    console.error("[MSAL] handleRedirectPromise failed:", err);
  }

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

bootstrap();
